import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { ls } from '@/utils/storage'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./languages', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const messages = loadLocaleMessages()
const defaultLocale = process.env.VUE_APP_I18N_LOCALE || 'fr'
// Honor a previously chosen language (per-client namespaced), if it's a locale we ship.
const savedLocale = ls.get('locale')
const initialLocale = (savedLocale && messages[savedLocale]) ? savedLocale : defaultLocale

export default new VueI18n({
  locale: initialLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  messages
})
